import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['selectedImagesCount', 'checkbox']

  connect () {
    this.toggleChecked = false
    this.count()
  }

  count () {
    if (!this.hasSelectedImagesCountTarget) return

    this.selectedImagesCountTarget.innerHTML = this.checkboxTargets.reduce((accumulator, element) => {
      if (element.checked) {
        accumulator += parseInt(element.dataset.imagesCount)
      }
      return accumulator
    }, 0)
  }

  toggleAll () {
    this.checkboxTargets.forEach(element => {
      element.checked = this.toggleChecked
    })
    this.toggleChecked = !this.toggleChecked
    this.count()
  }
}
